export const ProjectDetailsPage = (props) => {};
